import React, { useState } from 'react'
import { Row, Col, Input, Select, Form, Button, Modal, Tooltip } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import '../../Content/content-common.less'
import './add-user.less'
import UserCheckMenu from './userCheckMenu'
import { axiosPostAndHint } from '../../../components/reqAndHint'
import { getCheckedMenuId } from './userHelper'
import AsyncTree from './AsyncTree.js'
import { useSelector } from 'react-redux'
const { Option } = Select;
/**
 * 新增用户
 */
export default function AddUser() {
    const [form] = Form.useForm();
    const langValue = useSelector(state => state.langList.value)
    const [stateRoleId, setStateRoleId] = useState('4');// 默认为地方窗口
    const [checkedAreas, setCheckedAreas] = useState();

    function resetFormFields() {
        // console.log('form reset fields*');
        form.resetFields();
    }

    function onFinishFailed({ values, errorFields, outOfDate }) {
        // console.log("adduser form onFinishFailed:", values, errorFields, outOfDate);
        Modal.warn({ title: '用户信息验证未通过，请回顶部修改' });
    }

    function onFinish(values) {
        // console.log("adduser form onFinish:", values);
        let checkedMenuArr = getCheckedMenuId();
        // console.log("checkedMenuArr", checkedMenuArr);
        let checkedAreaIds = checkedAreas;//选中地区的id
        if (!checkedAreaIds ?.length) {
            Modal.warn({ title: '请先关联地区' });
            return;
        }

        if (!checkedMenuArr ?.length) {
            Modal.warn({ title: '请先设定权限' });
            return;
        }

        //因暂用不到开票点（billSpot）字段，暂用默认值‘001’代替。后续若该功能确认不需要再行删除250512
        axiosPostAndHint('/user/add', { ...values, menuIds: checkedMenuArr, AIds: checkedAreaIds, billSpot: '001' }, () => {
            // resetFormFields()
            document.getElementById('/view/user/list') ?.click();
        });

    }

    function onValChange(val, allVals) {
        // console.log("onvalChange:", val, allVals);
        let key = Object.keys(val)[0];
        // console.log("onValChange key:", key);
        if (key == "roleId") {
            setStateRoleId(val['roleId']);
        }
    }


    let submitBtnStyle = {
        'height': '60px',
        'backgroundColor': '#526be8',
        'borderRadius': '4px',
    }

    return (
        <div className="add-user">
            <Form
                name="add-user"
                form={form}
                onFinishFailed={onFinishFailed}
                onFinish={onFinish}
                initialValues={{ userStatus: 'on', roleId: '4', password: '111111' }}
                onValuesChange={onValChange}
            >
                <div className='user-info'>
                    <h1 className="info-title">{langValue == 0 ? '用户信息 User Info' : (langValue == 1 ? '用户信息' : 'User Info')}</h1>
                    <div className='info-content'>
                        <Row gutter={[2, { xs: 1, sm: 2, md: 3, lg: 4 }]} sytle={{ 'width': '60%' }}>
                            <Col className="gutter-row" span={6}>
                                <Form.Item
                                    name="account"
                                    rules={[{ required: true, message: '请输入用户账号' }]}
                                >
                                    <div className="input-wrapper">
                                        <label htmlFor="account">{langValue == 0 ? '账号Account No.' : (langValue == 1 ? '账号' : 'Account No.')}：</label>
                                        <Input id="account" placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')} className="u-input" />
                                    </div>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <Form.Item
                                    name="uname"
                                    rules={[{ required: true, message: '请输入用户名称' }]}
                                >
                                    <div className="input-wrapper">
                                        <label htmlFor="uname">{langValue == 0 ? '名称Username' : (langValue == 1 ? '名称' : 'Username')}：</label>
                                        <Input id="uname" placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')} className="u-input" />
                                    </div>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <div className="input-wrapper">
                                    <label htmlFor="role">{langValue == 0 ? '职称Job Title' : (langValue == 1 ? '职称' : 'Job Title')}：</label>
                                    {/* 换行 */}
                                    <div></div>
                                    <Form.Item
                                        name="roleId"
                                        rules={[{ required: true, message: '请选择职称' }]}
                                    >
                                        <Select placeholder={langValue == 0 ? '请选择Please select' : (langValue == 1 ? '请选择' : 'Please select')} style={{ width: 200 }} >
                                            <Option value="4" key="4">{langValue == 0 ? '地区财务窗口Regional financial window' : (langValue == 1 ? '地区财务窗口' : 'Regional financial window')}</Option>
                                            <Option value="3" key="3">{langValue == 0 ? '一般财务同仁General financial colleagues' : (langValue == 1 ? '一般财务同仁' : 'General financial colleagues')}</Option>
                                            <Option value="2" key="2">{langValue == 0 ? '财务管理员Financial administrator' : (langValue == 1 ? '财务管理员' : 'Financial administrator')}</Option>
                                        </Select>
                                    </Form.Item>
                                </div>
                            </Col>
                            {/* <Col className="gutter-row" span={6}>
                                {(stateRoleId == '2' || stateRoleId == '3') ?
                                    (
                                        <div className="input-wrapper" >
                                            <label htmlFor="bill-site">{langValue == 0 ? '关联开票点Related Ticket points' : (langValue == 1 ? '关联开票点' : 'Related Ticket points')}：</label>
                                            <Form.Item name="billSpot"
                                                rules={[{ required: true, message: '请输入开票点' }]}>
                                                <Input id="bill-site" className="u-input" placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')} />
                                            </Form.Item>
                                        </div>
                                    ) : null}
                            </Col> */}

                            <Col className="gutter-row" span={6}>
                                <Form.Item
                                    name="password"
                                    rules={[
                                        {
                                            required: true,
                                            message: '请输入用户密码'
                                        }
                                    ]}
                                >
                                    <div className="input-wrapper">
                                        <label htmlFor="password">{langValue == 0 ? <span>密码（默认 111111）<br />Password(Default 111111)</span> : (langValue == 1 ? '密码（默认 111111）' : 'Password (Default 111111)')}：</label>
                                        <br />
                                        <Input.Password
                                            defaultValue='111111'
                                            placeholder={langValue == 0 ? '请输入密码Enter Password' : (langValue == 1 ? '请输入密码' : 'Enter Password')} id="password"
                                            iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                            style={{ paddingLeft: 10 }}
                                        />
                                    </div>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <div className="input-wrapper">
                                    <label htmlFor="userStatus">{langValue == 0 ? '状态Status' : (langValue == 1 ? '状态' : 'Status')}</label>
                                    {/* 换行 */}
                                    <div></div>
                                    <Form.Item
                                        name="userStatus"
                                    >
                                        <Select style={{ width: 120 }} >
                                            <Option value="on" key="on">{langValue == 0 ? '启用Active' : (langValue == 1 ? '启用' : 'Active')}</Option>
                                            <Option value="off" key="off">{langValue == 0 ? '停用Inactive' : (langValue == 1 ? '停用' : 'Inactive')}</Option>
                                        </Select>
                                    </Form.Item>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className='user-info'>
                    <h1 className="info-title">{langValue == 0 ? '关联地区 Related regions' : (langValue == 1 ? '关联地区' : 'Related regions')}</h1>
                    <div className='info-content'>
                        <AsyncTree handleCheck={(checkedKeys, event) => {
                            // console.log('checkedKeys:', checkedKeys);
                            // console.log('event:', event);
                            setCheckedAreas(checkedKeys);
                        }} />
                    </div>

                    <div style={{ paddingBottom: 50, marginLeft: 24 }}>
                        <h2>{langValue == 0 ? '已选地区 Selected regions' : (langValue == 1 ? '已选地区' : 'Selected regions')}：</h2>
                        {checkedAreas ?.map(area => {
                            return <Tooltip key={area} title={area ?.split('-')[0]}>
                                <Button style={{ margin: 10 }}>{area ?.split('-')[0]}</Button>
                            </Tooltip>
                        })}
                    </div>

                </div>
                <div className='user-info'>
                    <h1 className="info-title">{langValue == 0 ? '权限设定 Permission settings' : (langValue == 1 ? '权限设定' : 'Permission settings')}</h1>
                    <div className='info-content'>
                        <UserCheckMenu roleId={stateRoleId} queryType='byRole' />
                    </div>

                </div>
                <div style={{ marginLeft: 24, paddingBottom: 24 }}>
                    <Button type="primary" htmlType="submit" style={submitBtnStyle}>
                        {langValue == 0 ? '确定提交Confirm and Submit' : (langValue == 1 ? '确定提交' : 'Confirm and Submit')}
                    </Button>
                </div>
            </Form>
        </div >
    )
}
